import { useState, useEffect, useRef } from 'react';
import API from '../functions/api';
import { formatPostcode } from '../functions/textFormatting';
import { getStateFromPostcode } from '../functions/location';
import TextField from '../audi-ui-components/TextField';
import Button from '../audi-ui-components/Button';
import IconPoiOnMap from '../audi-ui-components/icons/PoiOnMap';
import IconCancel from '../audi-ui-components/icons/Cancel';
import cn from 'classnames';
import _findIndex from 'lodash/findIndex';

import { connect } from 'react-redux';
import {
  updateSelectedDealer
} from '../redux/Dealers';
const mapStateToProps = state => {
  return {
    currentDealer: state.dealers.current
  };
}
const mapDispatchToProps = dispatch => {
  return {
    updateSelectedDealer: (d) => {dispatch(updateSelectedDealer(d));}
  }
}

/*
 * This component adds values.dealer to the form, this needs to be removed before sending to backend
 */

const DealerByPostcodeModule = ({
  postcodeName = "searchPostcode",
  title = "Find your nearest dealer by postcode",
  description,
  fieldDescription,
  floatingLabel,
  postcodeLabel = "Postcode *",
  values, errors, touched, setValues, setFieldValue, setFieldTouched, submitCount,
  formName = "",
  additionalDealerFields = "",
  additionalLocationFields = "",
  currentDealer,
  updateSelectedDealer,
  updateOnExtChange = false,
  onEnterPostcode = ()=>{},
  onSelectDealer = ()=>{},
  theme
}) => {
  
  const [isLoading, setIsLoading] = useState(false);
  const [options, setOptions] = useState(null);
  const [fetchDealersError, setFetchDealersError] = useState(null);
  
  useEffect(()=>{
    if (currentDealer && currentDealer.dealerId) {
      // dealer locked
      // https://github.com/jaredpalmer/formik/issues/930
      setTimeout(() => {
        setFieldValue("dealerId", currentDealer.dealerId, false);
        setFieldValue("dealerName", currentDealer.name, false);
        setFieldValue("dealer", currentDealer, false);
      }, 50);
    } else {
      // console.log("dealer not locked");
      setTimeout(() => {
        setFieldValue("dealerId", "", false);
        setFieldValue("dealerName", "", false);
        if (!values[postcodeName]) { setFieldValue(postcodeName, "", false); }
      }, 50);
      // if (values && values[postcodeName] && /^\d{4}$/.test(values[postcodeName])) {
      //   getDealer(values[postcodeName]);
      // }
    }
  }, []);
  
  useEffect(()=>{
    // console.log("variantIds changed", values.variantIds);
    if (/^\d{4}$/.test(values[postcodeName])) {
      getDealer(values[postcodeName]);
    }
  }, [values.variantId, values.variantIds]);
  
  useEffect(()=>{
    if (updateOnExtChange && !currentDealer?.dealerId) {
      if (values && values[postcodeName] && /^\d{4}$/.test(values[postcodeName])) {
        getDealer(values[postcodeName]);
      }
    }
  }, [values[postcodeName]]);
  
  const handleChangePostcode = (v) => {
    setFieldValue(postcodeName, v);
    if (/^\d{4}$/.test(v)) {
      getDealer(v);
      onEnterPostcode(v);
    }
    setFieldValue("dealerId", "", false);
    setFieldValue("dealerName", "", false);
    setFieldValue("dealer", null, false);
    updateSelectedDealer(null);
    setOptions(null);
  }
  
  const getDealer = (postcode) => {
    // console.log("getDealer");
    // setFetchDealersError(null);
    setIsLoading(true);
    API.post(
      `${process.env.RAZZLE_GQLAPI}`,
      {
          query: /* GraphQL */`query ($filter: LocationDtoFilterInput) {
            locationsByPostcode(postcode: "${postcode}", where: $filter, take: 3, formName: "${formName}" ${values.variantId ? `, variant: ${values.variantId}` : ``} ${values.variantIds ? `, variantIds: "${values.variantIds.join(",")}"` : ``}) {
              items {
                id
                name
                suburb
                postcode
                state
                ${additionalLocationFields}
                dealer {
                  dealerCode
                  dealerId
                  status
                  name
                  dataCollectionPolicy
                  ${additionalDealerFields}
                }
              }
            }
          }`,
          variables: {
            filter: {and: {type: {eq: "Sales"}, status: {eq: true}, dealer: {status: {eq: true}}}}
          }
      }
    ).then(response => {
        // console.log(response);
        let items = response.data?.data?.locationsByPostcode?.items || [];
        if (items.length > 0) {
          let opts = [items[0]];
          let requestedState = getStateFromPostcode(postcode);
          let hasInStateLoc = items[0].state === requestedState;
          if (!hasInStateLoc) {
            // all locations are out of state
            opts = items;
          } else {
            // the first location is in state, check the rest
            if (items.length > 1 && items[1].state === requestedState) {
              opts.push(items[1]);
            }
            if (items.length > 2 && items[2].state === requestedState) {
              opts.push(items[2]);
            }
          }
          setOptions(opts);
          if (values.dealerId) {
            let i = _findIndex(opts, function (o) {return o.dealer.dealerId === values.dealerId});
            // console.log("check dealer", i);
            if (i === -1) {
              setFieldValue("dealerId", "");
              setFieldValue("dealerName", "", false);
              updateSelectedDealer(null);
            }
          }
          setFetchDealersError(null);
        } else {
          setOptions([]);
          setFetchDealersError("No dealers found for that postcode");
        }
        setIsLoading(false);
        setFetchDealersError(null);
    }).catch((err) => {
        let msg = "There was a problem getting the list of dealers.";
        if (err.response?.status === 404) {
          msg = "Sorry, we couldn't find any dealers for that postcode.";
        } else if (values.variantId) {
          msg = "We couldn't find any dealers for that postcode who sell your selected model.";
        }
        setOptions([]);
        setFetchDealersError(msg);
        setIsLoading(false);
    });
  }
  
  if (currentDealer && currentDealer.dealerId) {
    if (errors[postcodeName] || values[postcodeName]) {
      return (
        <TextField name={postcodeName}
          value={values[postcodeName] || ""}
          label={postcodeLabel}
          onChange={(v) => { setFieldValue(postcodeName, v); }}
          isInvalid={errors[postcodeName] && touched[postcodeName]}
          invalidMessage={errors[postcodeName]}
          onBlur={() => { setFieldTouched(postcodeName); }}
          className="form-field"
        />
      );
    }
    return null;
  }
  
  return (
    <div className={cn("form-module dealer-by-postcode", {"is-invalid": errors.dealerName})}>
      {title && <p className="aui-headline-5 mb-2"><b>{title}</b></p>}
      {description && <p>{description}</p>}
      <TextField name={postcodeName}
        value={values[postcodeName] || ""}
        label={postcodeLabel}
        floatingLabel={floatingLabel}
        description={fieldDescription}
        onChange={handleChangePostcode}
        isInvalid={errors[postcodeName] && touched[postcodeName]}
        invalidMessage={errors[postcodeName]}
        onBlur={() => { setFieldTouched(postcodeName); }}
        theme={theme === "dark" ? "light" : null}
      />
      <div className="mt-4">
        {isLoading && <p>Finding dealers...</p>}
        {!isLoading && fetchDealersError && <p className="aui-color-text-red">{fetchDealersError}</p>}
        {options && options.map((opt,i) => {
          let hasSelected = Boolean(values.dealerId);
          let isSelected = hasSelected && values.dealerId === opt.dealer.dealerId;
          return (
            <div
              onClick={()=>{
                setFieldValue("dealerId", opt.dealer.dealerId);
                setFieldValue("dealerName", opt.dealer.name);
                setFieldValue("dealer", opt, false);
                updateSelectedDealer(opt.dealer);
                onSelectDealer(opt);
              }}
              className={cn(
                "dealer",
                {
                  "selected": isSelected,
                  "not-selected": hasSelected && !isSelected
                }
              )}
              key={`opt${i}`}
            >
              <div className="px-3 py-2">
                <div className="row flex-nowrap">
                  <div className="col-auto"><IconPoiOnMap small /></div>
                  <div className="col d-flex align-items-start justify-content-center flex-column"><span className="aui-headline-5 d-block"><b>{opt.dealer.name}</b></span>{isSelected && <b className="aui-small">{opt.suburb} {opt.state}</b>}</div>
                  {isSelected && options.length > 1 && <div className="col-auto">
                    <Button variant="icon" theme={theme === "dark" ? "light" : null} icon={<IconCancel large />} onClick={()=>{
                      setFieldValue("dealerId", "");
                      setFieldValue("dealerName", "");
                      setFieldValue("dealer", null, false);
                      updateSelectedDealer(null);
                    }} />
                  </div>}
                </div>
              </div>
            </div>
          );
        })}
        {errors.dealerName && !errors[postcodeName] && !fetchDealersError && (touched.dealerName || submitCount > 0) && <p className="aui-textfield__error">{errors.dealerName}</p>}
      </div>
    </div>
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(DealerByPostcodeModule);
